import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { useEffect, useState } from "react";
import { removeMyCar, updateMyCar } from "../redux/slices/carSlice";
import { useNavigate, useSearchParams } from "react-router-dom";
import { WashBookingDetailsOverlay } from "../components/Profile/WashBookingDetailsOverlay";
import { DeleteCarCard } from "../components/Profile/DeleteCarCard";
import { Car } from "../types/car.types";
import { CarDetailsCard } from "../components/Dashboard/CarDetailsCard";
import { getBooking } from "../redux/slices/admin.slices/bookings.slice";
import { WashBookingsList } from "../components/Profile/WashBookingsList";
import { ProductOrdersList } from "../components/Profile/ProductOrdersList";
import { CarsList } from "../components/Profile/CarsList";
import { HeaderProfile } from "../components/Profile/ProfileHeader";
import { getOrder } from "../redux/slices/admin.slices/orders.slice";
import { Addresses } from "../components/Profile/Addresses";
import { EditProfileCard } from "../components/Profile/EditProfileCard";
import { User } from "../types/slice.types";
import { editProfile } from "../redux/slices/authSlice";
import { WashBooking } from "../types/admin/washBookings.types";
import { ProductOrderDetailsOverlay } from "../components/Profile/ProductOrderDetailsOverlay";
import { ProductOrder } from "../types/admin/productOrder.types";

export const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParam] = useSearchParams();

  const auth = useSelector((state: RootState) => state.auth);
  const myCars = useSelector((state: RootState) => state.myCars);
  const washBookings = useSelector(
    (state: RootState) => state.bookings.bookings,
  );
  const productOrders = useSelector(
    (state: RootState) => state.orders.productOrders,
  );

  const [showDeleteCard, setShowDeleteCard] = useState(false);
  const [showEditCard, setShowEditCard] = useState(false);
  const [selectedCar, setSelectedCar] = useState<Car | undefined>(undefined);
  const [showEditProfile, setShowEditProfile] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});

  useEffect(() => {
    if (auth.user === undefined) return;

    if (!auth.user) {
      navigate("/");
    }
  }, [auth.user]);

  useEffect(() => {
    if (
      auth.user?.bookings &&
      auth.user?.bookings.length > 0 &&
      washBookings.length === 0
    ) {
      dispatch(getBooking({ ids: auth.user.bookings }) as any);
    }
  }, [auth.user?.bookings]);

  useEffect(() => {
    if (
      auth.user?.orders &&
      auth.user?.orders.length > 0 &&
      productOrders.length === 0
    ) {
      dispatch(getOrder({ ids: auth.user.orders }) as any);
    }
  }, [auth.user?.orders]);

  useEffect(() => {
    if (auth.user?.orders && auth.user?.orders.length > 0) {
    }
  }, []);

  const handleCardClose = () => {
    setShowDeleteCard(false);
    setShowEditCard(false);
    setSelectedCar(undefined);
  };

  const handleProfileUpdate = async (data: Partial<User>) => {
    const errors: any = {};
    if (!data.name) errors.name = "Required";
    if (!data.email) errors.email = "Required";
    if (!data.phone) errors.phone = "Required";
    if (!data.city) errors.city = "Required";

    if (Object.keys(errors).length) {
      setFieldErrors(errors);
      return;
    }
    dispatch(editProfile(data) as any);
    setShowEditProfile(false);
  };

  const handleCarDelete = () => {
    dispatch(
      removeMyCar({
        carId: selectedCar?._id as string,
      }) as any,
    );
    handleCardClose();
  };

  const handleCarEdit = (carData: Partial<Car>) => {
    dispatch(
      updateMyCar({
        updateDetails: carData,
        carId: selectedCar?._id as string,
      }) as any,
    );
    handleCardClose();
  };

  return (
    <div className="w-full flex justify-center mt-10">
      <div className="w-[90%] p-6 bg-popupLight dark:bg-popupDark text-primaryText dark:text-primaryTextDark rounded-lg shadow-lg">
        <HeaderProfile
          user={auth.user}
          handleProfileEdit={() => setShowEditProfile(true)}
        />

        <div className="border-t border-primaryText/10 dark:border-primaryTextDark/10 mb-6" />
        <Addresses />

        {myCars?.cars?.length ? (
          <CarsList
            cars={myCars.cars}
            setSelectedCar={setSelectedCar}
            setShowEditCard={setShowEditCard}
            setShowDeleteCard={setShowDeleteCard}
          />
        ) : null}

        <WashBookingsList
          washBookings={washBookings}
          setSearchParam={setSearchParam}
        />
        <ProductOrdersList
          orders={productOrders}
          setSearchParam={setSearchParam}
        />
      </div>

      {showDeleteCard && selectedCar && (
        <DeleteCarCard
          onClose={handleCardClose}
          onConfirm={handleCarDelete}
          carNumberMatch={selectedCar.number}
        />
      )}

      {showEditProfile && (
        <EditProfileCard
          user={auth.user as Partial<User>}
          onSubmit={handleProfileUpdate}
          fieldErrors={fieldErrors}
          setFieldErrors={setFieldErrors}
          onClose={() => setShowEditProfile(false)}
        />
      )}

      {showEditCard && selectedCar && (
        <CarDetailsCard
          onClose={handleCardClose}
          onSubmit={handleCarEdit}
          carDetails={selectedCar}
        />
      )}

      {washBookings?.length > 0 && searchParams.get("bookingId") && (
        <WashBookingDetailsOverlay
          booking={
            washBookings?.find(
              (b) => b._id === searchParams.get("bookingId"),
            ) as WashBooking
          }
          onClose={() => navigate("/profile")}
        />
      )}

      {productOrders?.length > 0 && searchParams.get("orderId") && (
        <ProductOrderDetailsOverlay
          order={
            productOrders.find(
              (o) => o._id === searchParams.get("orderId"),
            ) as ProductOrder
          }
          onClose={() => navigate("/profile")}
        />
      )}
    </div>
  );
};
